<template>
<div class="page_transport">
  <div class="container py-5">
    <div class="page_topic_blcok my-4">
      <div class="topic_border">
        <p class="topic_eng">MEMBER</p>
        <p class="topic_cht">登入/加入會員</p>
      </div>
    </div>
    <!--會員欄位-->
    
    <!--麵包屑-->
    <!--<div class="menu_bread">
      <p>
        <router-link to="/home">上聯展覽</router-link>
        <span>＞</span>
        <router-link to="/member">廠商專區</router-link>
        <span>＞登入/加入會員</span>
      </p>
    </div>
    -->
    <div class="member_login_block">
      <!--<h2>
        <img src="@/assets/icons/member_title.png" /> 登入/加入會員
      </h2>
      -->
      <div class="member_login_flex">
        <!-- 登入表單 -->
        <form class="member_login_box col-lg-6 col-md-12">
          <h4>登入廠商會員</h4>
          <div>
            <label for="member_account">帳　號</label>
            <input id="member_account" type="text" placeholder="統一編號"/>
            <span style="font-size:14px;">( 帳號為您的公司統編 )</span>
          </div>
          <div>
            <label for="member_pwd">密　碼</label>
            <input id="member_pwd" type="password" />
            <span style="font-size:14px;">( 密碼長度為 6 ~ 20 個字元 )</span>
          </div>
          <p style="font-size:14px;padding-left:200px;"><router-link :to="{name: 'forget_pwd'}">忘記密碼</router-link></p>
          <div style="padding-left:15px;">
            <label for="member_verify">驗證碼</label>
            <input id="member_verify" type="text" placeholder="請輸入右方數字" />
            <div style="display:inline-flex;width:80px;height:35px;border:1px solid black;align-items:center;justify-content:center;">
              <span><em>1547</em></span>
            </div>
            <div><a href="#">刷新驗證碼</a></div>
          </div>
          <router-link :to="{name: 'record'}" tag="button" class="submit_btn red" style="margin:10px 0 0 100px;">確 認 送 出</router-link>
        </form>

        <!-- 分隔線 -->
        <p id="seperator" style="width:1px;height:230px;border-left:1px solid rgb(180, 180, 180);margin:10px 10px;" v-if="seperator()"></p>
        
        <!-- 加入表單 -->
        <form class="member_login_box col-lg-6 col-md-12">
          <h4>加入廠商會員</h4>
          <div>
            <label for="member_account">公司統編</label>
            <input id="member_account" type="text" placeholder="統一編號"/>
            <span style="font-size:14px;">( 此為廠商專區的登入帳號 )</span>
          </div>
          <div>
            <label for="member_pwd">密　碼</label>
            <input id="member_pwd" type="password" />
            <span style="font-size:14px;">( 密碼需為 6 ~ 20 個字元 )</span>
          </div>
          <div>
            <label for="member_verify">確認密碼</label>
            <input id="member_verify" type="text" />
          </div>
          <router-link :to="{name: 'member_join'}" tag="button" class="submit_btn blue" style="margin:10px 0 0 100px;">確 認 送 出</router-link>
        </form>
      </div>
    </div>

  </div>  
</div>



</template>

<script>
export default {
  data () {
    return{
    }
  },
  methods: {
    seperator: function(){
      if ($(window).width() < 1200){
        return false;
      }else {
        return true;
      }
    }
  },
  mounted() {
    $(window).resize(function(){
      if ($(window).width() < 1200){
        $('#seperator').hide();
      }else {
        $('#seperator').show();
      }
    })
  }
}
</script>

<style>
.member_login_block>h2 {
  border-bottom:3px solid rgb(10, 116, 0);
  padding:4px 0;
}

.member_login_flex {
  display:flex;
  justify-content: center;
  align-items: flex-start;
  padding-top:10px;
}

.member_login_box {
  height:auto;
}
.member_login_box>div {
  display:flex;
  flex-flow:row wrap;
  justify-content: flex-start;
  align-items: flex-end;
  margin-top: 10px;
}
.member_login_box input {
  height:35px;
  margin:0 10px;
}
.member_login_box h4 {
  padding-left:10px;
  border-bottom:1px solid rgb(10, 116, 0);
}
.member_login_box h4, .member_login_box label {
  font-weight:bold;
}
.member_login_box>div label {
  width:68px;
}
@media (max-width:1200px){
  .member_login_flex {
    flex-direction:column;
  }
  .member_login_box {
    margin-top:30px;
  }
}


/* btn */
.submit_btn{
  outline:none;
  border:0;
  margin:0;
  padding:0;
  box-sizing: border-box;
}
.submit_btn.red{
  background: rgba(255, 0, 51, 1);
  color:white;
  width:140px;
  height:40px;
  border:1px solid rgba(255, 255, 255, 1);
  border-radius: 5px;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.35);
}
.submit_btn.blue{
  background: rgba(25, 158, 216, 1);
  color:white;
  width:140px;
  height:40px;
  border:1px solid rgba(255, 255, 255, 1);
  border-radius: 5px;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.35);
}

</style>



// WEBPACK FOOTER //
// src/components/pages/member.vue